import numString from '@/utils/numString';

export default function MinutesText({ minutes }: { minutes: number }) {
  return (
    <span>
      {numString(minutes, 'minutes')} ({(minutes / 60).toFixed(1)} hours)
    </span>
  );
}
